export const FETCH_LIST_TRACKING = "[TRACKING_MANAGEMENT] FETCH_LIST_TRACKING";
export const FETCH_LIST_TRACKING_SUCCESS = "[TRACKING_MANAGEMENT] FETCH_LIST_TRACKING_SUCCESS";
export const FETCH_LIST_TRACKING_FAILED = "[TRACKING_MANAGEMENT] FETCH_LIST_TRACKING_FAILED";
